import styled from 'styled-components';

export const LayoutModuleStyled = styled.div`
    z-index: auto;
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% - 292px);
    height: 100%;
`;

export const ModuleHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 96px;
    padding-top: 25px;
    padding-bottom: 25px;
    margin: 0 24px;

    owc-typography[element='h4'] > span {
        font-size: 28px;
    }
`;

export const HeaderOptionsContainer = styled.div`
    display: flex;
    gap: 10px;
`;

export const ModuleSeparator = styled.div`
    position: sticky;
    top: 0;
    z-index: 110;
    width: calc(100% - 32px);
    height: 0;
    margin: 0 24px;
    background-color: var(--one-color-gray-50);

    &::after {
        position: absolute;
        top: 100%;
        width: 100%;
        height: 44px;
        content: '';
        background-color: var(--one-color-gray-50);
    }
`;

export const ModuleContent = styled.div`
    /* To table size */

    /* height: calc(100% - 152px); */
    margin: 0 24px 25px;
`;

export const ModuleScrollableContent = styled.div.attrs<{ 'data-testid'?: string }>({
    'data-testid': 'module-scrollable',
})`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-top: 4px;
    overflow: hidden auto;
`;
